import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as r, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconPhoneCall",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.528.948a.5.5 0 0 1 .55-.445 5 5 0 0 1 4.444 4.41.5.5 0 0 1-.994.113 4 4 0 0 0-3.555-3.529.5.5 0 0 1-.445-.55ZM2.009 2.034a.036.036 0 0 0-.002.016 7.98 7.98 0 0 0 .554 2.508l1.128-.94a.125.125 0 0 0 .041-.127l-.349-1.396A.125.125 0 0 0 3.26 2H2.083a.092.092 0 0 0-.065.023.035.035 0 0 0-.009.011Zm.992 3.459L4.33 4.385c.332-.276.476-.718.371-1.137l-.349-1.396A1.125 1.125 0 0 0 3.26 1H2.083c-.577 0-1.106.457-1.074 1.1a9.101 9.101 0 0 0 2.674 5.94c2.217 2.22 4.922 2.773 6.137 2.912.67.077 1.18-.463 1.18-1.077V8.738c0-.516-.352-.966-.853-1.091l-1.439-.36a1.125 1.125 0 0 0-1.068.297L6.394 8.832A8.804 8.804 0 0 1 4.39 7.334 8.226 8.226 0 0 1 3 5.493Zm4.35 3.796a9.892 9.892 0 0 0 2.583.67.05.05 0 0 0 .023-.002.046.046 0 0 0 .017-.01.096.096 0 0 0 .026-.072V8.738a.125.125 0 0 0-.095-.121l-1.439-.359a.125.125 0 0 0-.118.033l-.997.998Zm-.817-6.386a.5.5 0 0 1 .588-.394 3 3 0 0 1 2.37 2.4.5.5 0 1 1-.984.182 2 2 0 0 0-1.58-1.6.5.5 0 0 1-.394-.588Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, h, l, f, p, a) {
  return r(), i("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--phone-call"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Phone Call",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const C = /* @__PURE__ */ o(s, [["render", u]]);
export {
  C as default
};
//# sourceMappingURL=phone-call.js.map
